var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"molecule-available-spaces-trigger-on-mobile",class:{ active: _vm.isOpen },on:{"click":_vm.showAvailableSpaces}},[_c('AtomsCommonAtomIcon',{attrs:{"icon":"buildings-alt"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }